import React from "react";
import { get } from 'lodash';
import { Box, TextField, } from "@mui/material";
import { formatNumber } from "helpers/formatNumber";
import { useFormContext, Controller } from "react-hook-form";

const onWheelPreventChangeNumberField = (e) => {
  e.target.blur();
  e.stopPropagation();
};

const CustomTextInput = ({
   name,
   id,
   sx,
   children,
   label = "",
   validate,
   inputProps,
   hidden,
   onChange,
   disabled,
   multiline,
   rows,
   select,
   helperText,
   InputProps,
   labelProps = {},
   onKeyPress,
   onBlur,
   ...params
 }) => {
  const { control, formState } = useFormContext();
  const { errors } = formState;
  let parsedError = get(errors, name);

  return (
    <Box sx={{ height: "80px" }}>
      <Controller
        name={name}
        control={control}
        render={({ field }) => {
          const formattedValue = field.name.includes("price")
            ? formatNumber(field.value)
            : field.value;

          return (
            <TextField
              {...field}
              variant="outlined"
              id="outlined-basic"
              size="middle"
              hidden={hidden}
              error={!!parsedError || params.error || false}
              helperText={
                typeof helperText !== "object"
                  ? parsedError
                    ? parsedError.message
                    : params.helperText || helperText
                  : helperText
              }
              label={label}
              inputRef={field.ref}
              disabled={disabled}
              InputProps={{
                ...inputProps,
                autoComplete: 'new-password',
              }}
              onWheel={onWheelPreventChangeNumberField}
              sx={{ ...select, width: "100%" }}
              multiline={multiline}
              rows={rows}
              select={select}
              inputProps={inputProps}
              autoComplete="off"
              onChange={onChange || field.onChange}
              onBlur={onBlur || field.onBlur}
              InputLabelProps={labelProps}
              value={formattedValue === null ? "" : formattedValue}
            >
              {children}
            </TextField>
          );
        }}
        {...params}
      />
    </Box>
  );
};

export default CustomTextInput;
